(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["onna-rope-configurator"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__onnaRopeConfiguratorReady) return;
    window.__onnaRopeConfiguratorReady = true;

    const getRoot = (node) => node?.closest('[data-onna-rope-configurator]') || document.querySelector('[data-onna-rope-configurator]');

    const getVariantSelects = (root) => {
      const info = root?.closest('.product__info-container');
      return info?.querySelector('variant-selects') || null;
    };

    const findFieldset = (variantSelects, label) => {
      if (!variantSelects) return null;
      return [...variantSelects.querySelectorAll('fieldset')].find((fieldset) => {
        const legend = fieldset.querySelector('legend');
        return legend && legend.textContent.toLowerCase().includes(label.toLowerCase());
      }) || null;
    };

    const readOption = (variantSelects, label) => {
      const fieldset = findFieldset(variantSelects, label);
      return fieldset?.querySelector('input:checked')?.value || '';
    };

    const setProperty = (root, key, value) => {
      const input = root.querySelector('[data-rope-property="' + key + '"]');
      if (input) input.value = value;
    };

    const hexToRgb = (hex) => {
      const value = (hex || '#c4ae91').replace('#', '');
      const normalized = value.length === 3 ? value.split('').map((part) => part + part).join('') : value;
      return {
        r: parseInt(normalized.slice(0, 2), 16),
        g: parseInt(normalized.slice(2, 4), 16),
        b: parseInt(normalized.slice(4, 6), 16)
      };
    };

    const renderPhoto = (root) => {
      const photo = root?.querySelector('[data-onna-product-photo]');
      const canvas = root?.querySelector('[data-onna-rope-canvas]');
      if (!photo || !canvas) return;
      if (!photo.complete || !photo.naturalWidth) {
        if (!photo.dataset.onnaRenderBound) {
          photo.dataset.onnaRenderBound = 'true';
          photo.addEventListener('load', () => renderPhoto(root), { once: true });
        }
        return;
      }

      try {
        const width = photo.naturalWidth;
        const height = photo.naturalHeight;
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.clearRect(0, 0, width, height);
        context.drawImage(photo, 0, 0, width, height);
        const image = context.getImageData(0, 0, width, height);
        const selected = hexToRgb(root.dataset.onnaRopeColor || '#c4ae91');

        // La máscara sigue la silueta real de la tulipa, que se abre hacia abajo.
        // Así se incluyen también los hilos claros y las sombras de los laterales.
        const centerX = width * 0.533;
        const topY = height * 0.445;
        const bottomY = height * 0.86;

        for (let y = Math.floor(topY); y <= Math.ceil(bottomY); y += 1) {
          const progress = Math.max(0, Math.min(1, (y - topY) / (bottomY - topY)));
          const halfWidth = width * (0.23 + (0.16 * progress));
          const left = Math.max(0, Math.floor(centerX - halfWidth));
          const right = Math.min(width - 1, Math.ceil(centerX + halfWidth));

          for (let x = left; x <= right; x += 1) {
            const index = (y * width + x) * 4;
            const red = image.data[index];
            const green = image.data[index + 1];
            const blue = image.data[index + 2];
            const luminance = (0.299 * red) + (0.587 * green) + (0.114 * blue);
            const chroma = Math.max(red, green, blue) - Math.min(red, green, blue);

            // El fondo es prácticamente blanco; solo se excluyen los píxeles
            // blancos puros y los metales negros/neutros.
            const isWhiteBackground = luminance > 251;
            const isDeepNeutralMetal = luminance < 78 && chroma < 20;
            const isRopePixel = !isWhiteBackground
              && !isDeepNeutralMetal
              && luminance > 48;

            if (!isRopePixel) continue;

            // Conserva luces, sombras y textura del cordón original.
            const shade = Math.max(0.32, Math.min(1.2, luminance / 178));
            image.data[index] = Math.min(255, Math.round(selected.r * shade));
            image.data[index + 1] = Math.min(255, Math.round(selected.g * shade));
            image.data[index + 2] = Math.min(255, Math.round(selected.b * shade));
          }
        }

        context.putImageData(image, 0, 0);
        photo.style.display = 'none';
        canvas.style.display = 'block';
      } catch (error) {
        canvas.style.display = 'none';
        photo.style.display = 'block';
      }
    };

    const applyVisual = (root, button) => {
      if (!root || !button) return;
      const name = button.dataset.ropeName;
      const ref = button.dataset.ropeRef;
      const color = button.dataset.ropeColor;
      const shadow = button.dataset.ropeShadow;
      root.style.setProperty('--onna-rope-color', color);
      root.style.setProperty('--onna-rope-shadow', shadow);

      // Set SVG presentation attributes directly as well as CSS variables.
      // This keeps the rope color reliable after Shopify re-renders the variant picker.
      root.querySelectorAll('[data-onna-rope-color-stroke]').forEach((element) => element.setAttribute('stroke', color));
      root.querySelectorAll('[data-onna-rope-shadow-stroke]').forEach((element) => element.setAttribute('stroke', shadow));
      root.dataset.onnaRopeColor = color;
      renderPhoto(root);

      root.querySelectorAll('.onna-rope-swatch').forEach((item) => {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      const selectedName = root.querySelector('[data-rope-selected-name]');
      const selectedRef = root.querySelector('[data-rope-selected-ref]');
      if (selectedName && selectedName.textContent !== name) selectedName.textContent = name;
      if (selectedRef && selectedRef.textContent !== ref) selectedRef.textContent = ref;
      setProperty(root, 'name', name);
      setProperty(root, 'ref', ref);
      setProperty(root, 'summary', 'ONNA 52 cm · ' + name + ' · Ref. ' + ref);
    };

    const getVariants = (root) => {
      const node = root?.querySelector('[data-onna-variants]');
      return node ? JSON.parse(node.textContent) : [];
    };

    const setVariantId = (root, variant) => {
      const form = document.getElementById(root?.dataset.formId || '');
      const idInput = form?.querySelector('input[name="id"]');
      if (idInput && variant) idInput.value = variant.id;
    };

    const syncRoot = (root) => {
      if (!root) return;
      const variantSelects = getVariantSelects(root);
      const ropeFieldset = findFieldset(variantSelects, 'Color cuerda');
      if (ropeFieldset) ropeFieldset.hidden = true;
      const currentName = readOption(variantSelects, 'Color cuerda');
      const button = [...root.querySelectorAll('.onna-rope-swatch')].find((item) => item.dataset.ropeName === currentName)
        || root.querySelector('.onna-rope-swatch[aria-pressed="true"]')
        || root.querySelector('.onna-rope-swatch');
      applyVisual(root, button);
    };

    const activate = (button) => {
      const root = getRoot(button);
      if (!root) return;
      const variantSelects = getVariantSelects(root);
      const ropeFieldset = findFieldset(variantSelects, 'Color cuerda');
      const nativeInput = ropeFieldset && [...ropeFieldset.querySelectorAll('input')].find((input) => input.value === button.dataset.ropeName);

      // Paint first so the customer sees the color immediately.
      applyVisual(root, button);

      if (nativeInput && !nativeInput.checked) nativeInput.click();

      const firstOption = readOption(variantSelects, 'Color florón');
      const secondOption = readOption(variantSelects, 'Estructura pantalla');
      const variant = getVariants(root).find((item) => item.option1 === firstOption && item.option2 === secondOption && item.option3 === button.dataset.ropeName)
        || getVariants(root).find((item) => item.option3 === button.dataset.ropeName);
      setVariantId(root, variant);
      window.setTimeout(() => syncRoot(document.querySelector('[data-onna-rope-configurator]')), 180);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-rope-name]');
      if (!button) return;
      event.preventDefault();
      activate(button);
    });

    const boot = () => {
      document.querySelectorAll('[data-onna-rope-configurator]').forEach((root) => {
        syncRoot(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    new MutationObserver(boot).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
